<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="活动表上传记录"
    width="1100px"
    :close-on-click-modal="false"
    @open="handleOpen"
  >
    <el-table
      :data="tableData.records"
      border
      size="mini"
      v-loading="loading"
      max-height="520"
      :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column prop="uploadYear" label="上传年份" min-width="110" show-overflow-tooltip />
      <el-table-column prop="uploadMonth" label="上传月份" min-width="110" show-overflow-tooltip />
      <el-table-column prop="folderName" label="上传文件夹名称" min-width="180" show-overflow-tooltip />
      <el-table-column prop="imageName" label="图片名称" min-width="220" show-overflow-tooltip />
      <el-table-column prop="generateStatus" label="生成状态" min-width="120" show-overflow-tooltip />
      <el-table-column prop="failReason" label="失败原因" min-width="180" show-overflow-tooltip />
      <el-table-column prop="uploader" label="上传人" min-width="120" show-overflow-tooltip />
      <el-table-column prop="createdDateName" label="上传时间" min-width="180" show-overflow-tooltip />
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableData.pageNum"
        :page-size="tableData.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total"
      />
    </div>
  </el-dialog>
</template>

<script>
import mockService from '../../mockService'

export default {
  name: 'ActivityUploadRecordsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      tableData: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleOpen () {
      this.tableData.pageNum = 1
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      mockService.getActivityUploadRecords({
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize
      }).then(res => {
        this.tableData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizeChange (pageSize) {
      this.tableData.pageNum = 1
      this.tableData.pageSize = pageSize
      this.fetchList()
    },
    handleCurrentChange (pageNum) {
      this.tableData.pageNum = pageNum
      this.fetchList()
    }
  }
}
</script>

<style lang="stylus" scoped>
.pagination-wrap
  display flex
  justify-content flex-end
  padding-top 16px
</style>
